import request from '@teetsh/app/src/utils/request';
import useNotification from '@teetsh/app/src/containers/App/Notifications/useNotification';
import { useSchoolSchoolyear } from '@teetsh/app/src/containers/App/context/SchoolyearSchoolProvider';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { LivretEval } from '@teetsh/app/src/containers/Livrets/types/livret';
import livretKeys from '@teetsh/app/src/containers/Livrets/queries/keys';
import { useTranslation } from 'react-i18next';

function duplicateSocle({
  schoolyearId,
  schoolId,
  livretEleveId,
  livretEvalId,
  codeSocle,
}: {
  schoolyearId: string;
  schoolId: string;
  livretEvalId: string;
  livretEleveId: string;
  codeSocle: string;
}) {
  const requestURL = `/schoolyears/${schoolyearId}/schools/${schoolId}/livrets/${livretEvalId}/livrets-eleves/${livretEleveId}/socles/${codeSocle}/duplicate`;
  return request(requestURL, {
    method: 'POST',
  });
}

interface Props {
  livretEleveId: string;
  livretEvalId: string;
}

export function useDuplicateSocle(props: Props) {
  const { notifySuccess, notifyError } = useNotification();
  const { schoolyear, school } = useSchoolSchoolyear();
  const { livretEleveId, livretEvalId } = props;
  const { t } = useTranslation(['carnet']);
  const queryClient = useQueryClient();
  const { mutateAsync } = useMutation<LivretEval, any, string>({
    mutationFn: (codeSocle: string) =>
      duplicateSocle({
        schoolyearId: schoolyear.id,
        schoolId: school.id,
        livretEvalId,
        livretEleveId,
        codeSocle,
      }),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: livretKeys.livretDetail(
          schoolyear.id,
          school.id,
          livretEvalId,
        ),
      });
      notifySuccess({
        title: t('carnet:messages.socle.duplicateSuccess'),
      });
    },
    onError: () => {
      notifyError({
        title: t('carnet:messages.socle.duplicateError'),
      });
    },
  });
  return mutateAsync;
}
